import type { ColumnType, ColumnsType } from 'antd/es/table';
import type { GlobalToken } from 'antd/es/theme/interface';
import type { TableData, TableHeader } from '@/types';

const findColumnCell = (record: TableData, columnId: string) =>
  record.columns.find((columnItem) => columnItem.id === columnId);

/**
 * Maps Campaigns `TableHeader[]` to Ant Design columns; cells read `record.columns` by id (same as `TableRow`).
 */
export const buildCampaignsEchoColumns = (
  headers: TableHeader[],
  token: GlobalToken
): ColumnsType<TableData> => {
  return headers.map((header): ColumnType<TableData> => {
    const align = header.styleOptions?.align === 'right' ? 'right' : 'left';
    const minWidth = header.styleOptions?.minWidth ?? 0;

    const column: ColumnType<TableData> = {
      key: header.id,
      title: header.label,
      align,
      sorter: header.sortable ?? false,
      minWidth,
      onHeaderCell: () => ({
        style: { color: token.colorTextSecondary, ...header.style },
      }),
      render: (_value, record) => {
        const columnCell = findColumnCell(record, header.id);
        if (!columnCell) {
          return null;
        }
        return columnCell.value;
      },
      onCell: (record) => {
        const columnCell = findColumnCell(record, header.id);
        return {
          style: columnCell?.style,
        };
      },
    };

    return column;
  });
};
